import React from 'react'
import { AppContext } from '../../App'
import * as Request from '../../utilities/request'

import { Col, Row } from 'react-bootstrap'
import { Loading } from '../ui/Loading/Loading'
import { dollarFormat, properCase } from '../../utilities/format'
import { InvoicedInPeriod, UtilisationPeriod } from '../../../../back-end/common/billyDashboard'
import DashboardCard from './dashboardCard'
import { TestingStaff } from '../../screens/dashboard/dashboardWrapper'

interface InvoicedForPeriodProps {
	period: UtilisationPeriod
	firmView: boolean
	testingStaff?: TestingStaff
}

const InvoicedForPeriod = (props: InvoicedForPeriodProps) => {
	const { appState } = React.useContext(AppContext)

	const [invoicedInPeriod, setInvoicedInPeriod] = React.useState<InvoicedInPeriod | null>(null)
	const [errorMsg, setErrorMsg] = React.useState<string | null>(null)

	React.useEffect(() => {
		const getData = async () => {
			const testingStaffXpmID = props.testingStaff ? '/' + props.testingStaff.xpmID : ''
			const invoicedRes = await Request.get(`billydashboard/periodinvoiced${testingStaffXpmID}?period=${props.period}&firm=${props.firmView}`)

			setInvoicedInPeriod(invoicedRes.data.invoicedInPeriod)

			if (!invoicedRes.data.success) {
				setErrorMsg(invoicedRes.data.message)
			}
		}

		setInvoicedInPeriod(null)
		setErrorMsg(null)
		if (appState.authState.isLoggedIn) {
			getData()
		}
	}, [appState.authState, props])

	if (errorMsg) {
		return (
			<DashboardCard background={props.period}>
				<div className="center-flex p-3">
					<span className="span-body-2 span-white">{errorMsg}</span>
				</div>
			</DashboardCard>
		)
	}

	if (!invoicedInPeriod) {
		return (
			<DashboardCard background={props.period}>
				<div className="center-flex">
					<Loading show style={{ color: 'white' }} />
				</div>
			</DashboardCard>
		)
	}

	return (
		<DashboardCard background={props.period}>
			<Row>
				<Col className="d-flex flex-column">
					<span className="span-body-2 span-bold span-white">{props.period === 'year' ? 'FYTD' : 'THIS ' + props.period.toUpperCase()} INVOICED</span>

					<span className="font-800-36-42 span-white">{dollarFormat(invoicedInPeriod.currentInvoiced)}</span>

					<span className="span-body-2 span-white">
						{dollarFormat(invoicedInPeriod.currentWrittenOff - invoicedInPeriod.currentWrittenUp)} Written Off/Up
					</span>
				</Col>
				<Col className="d-flex flex-column justify-content-between align-items-end" sm="auto">
					<div className="d-flex flex-column align-items-end">
						<span className="span-body-2 span-white">Last {props.period === 'year' ? 'FY' : properCase(props.period)}</span>

						<span className="font-700-18-26 span-white">{dollarFormat(invoicedInPeriod.previousInvoiced)}</span>
					</div>

					<span className="span-body-2 span-white">
						{dollarFormat(invoicedInPeriod.previousWrittenOff - invoicedInPeriod.previousWrittenUp)} Written Off/Up
					</span>
				</Col>
			</Row>
		</DashboardCard>
	)
}

export default InvoicedForPeriod
